import { ActionContext } from 'vuex';
import { State } from '@/models/main';

export interface ModuleScheduler {
  travelTimes: TravelTime;
}

export interface TravelTime {
  ['string']: string | number;
}

export const moduleScheduler = {
  namespaced: true,
  state: {
    travelTimes: {},
  },
  getters: {
    travelTimes: (state: ModuleScheduler): TravelTime => {
      return state.travelTimes;
    },
  },
  actions: {
    async setTravelTime({ commit }: ActionContext<ModuleScheduler, State>, travel_time: TravelTime): Promise<void> {
      commit('SET_TRAVEL_TIME', travel_time);
    },
  },
  mutations: {
    SET_TRAVEL_TIME(state: ModuleScheduler, travel_time: TravelTime): void {
      state.travelTimes = { ...state.travelTimes, ...travel_time };
    },
  },
};
